module.exports = __webpack_public_path__ + "img/wuguocheng.700b2cd0.png";